'use client';

import { createContext } from 'react';

import type { LoadingMaskRootContextInterface } from '../types/loading-mask-root.types';

export const LoadingMaskRootContext = createContext<LoadingMaskRootContextInterface>({});

LoadingMaskRootContext.displayName = 'LoadingMask.Root.Context';
